import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hideText'
})

export class HideTextPipe implements PipeTransform {
  transform(value: string, visibleStart: number, visibleMiddle: number, visibleEnd: number, mask: string = '*'): string {
    if (!value) {
      return '';
    }
    const totalLength = value.length;
    const totalLengthLeft = totalLength - visibleStart - visibleEnd;
    const hiddenChars = mask.repeat(totalLengthLeft / 2 - visibleMiddle)
    const middleIndexStart =  totalLength / 2;
    return value.substring(0, visibleStart) + hiddenChars + value.substring(middleIndexStart, middleIndexStart+ visibleMiddle) + hiddenChars + value.substring(totalLength - visibleEnd);
  }
}

